import Axios from "Services/Auth/AxiosInterceptors";

/**
 * @description All non-deleted visit types (incl. inactive/unpublished) with
 * draft, checkout config, resolved prices and signed icon URLs.
 */
export const GetVisitTypes = async () => {
  const {
    data: { result },
  } = await Axios.get(`/visit-type/list`);
  return result;
};

/**
 * @description Create a new visit type (inactive, empty draft). Slug is permanent.
 * Payload: { name, slug, description?, restricted?, behavior?, checkout? }
 * @returns { id }
 */
export const CreateVisitType = async (payload) => {
  const {
    data: { result },
  } = await Axios.post(`/visit-type/create`, payload);
  return result;
};

/**
 * @description Builder autosave. Any of: name, description, icon, restricted,
 * behavior, checkout { baseSku, features }, draft { questions }.
 */
export const UpdateVisitType = async (id, payload) => {
  const {
    data: { result },
  } = await Axios.patch(`/visit-type/${id}`, payload);
  return result;
};

/** @description Persist a drag-reorder: displayOrder = position in orderedIds. */
export const ReorderVisitTypes = async (orderedIds) => {
  const {
    data: { result },
  } = await Axios.patch(`/visit-type/reorder`, { orderedIds });
  return result;
};

/** @description Show/hide for patients. Activation requires a published version. */
export const SetVisitTypeActive = async (id, active) => {
  const {
    data: { result },
  } = await Axios.patch(`/visit-type/${id}/active`, { active });
  return result;
};

/**
 * @description Snapshot the draft into an immutable form version.
 * 400 returns the full problem list in errors[].
 * @returns { formVersionId, version }
 */
export const PublishVisitType = async (id) => {
  const {
    data: { result },
  } = await Axios.post(`/visit-type/${id}/publish`);
  return result;
};

/** @description Soft delete — hidden everywhere, data kept. */
export const DeleteVisitType = async (id) => {
  const {
    data: { result },
  } = await Axios.delete(`/visit-type/${id}`);
  return result;
};

/** @description Publish history for a type, newest first (paginated). */
export const GetVisitTypeVersions = async (id, page = 1, perPage = 20) => {
  const {
    data: { result },
  } = await Axios.get(`/form-version/${id}/versions?page=${page}&perPage=${perPage}`);
  return result;
};

/** @description One immutable published form version. */
export const GetFormVersion = async (formVersionId) => {
  const {
    data: { result },
  } = await Axios.get(`/form-version/version/${formVersionId}`);
  return result;
};

/**
 * @description Icon upload (image only). Returns { key } — PATCH it onto the
 * type as "icon".
 */
export const UploadVisitTypeIcon = async (formData) => {
  const {
    data: { result },
  } = await Axios.post(`/visit-type/upload-icon`, formData, {
    headers: { "content-type": "multipart/form-data" },
  });
  return result;
};
